import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { Box, Fab, Typography } from '@mui/material';
import { useState } from 'react';

import NeedHelpDialog from '@src/components/NeedHelp/NeedHelpDialog';

export default function NeedHelpCard() {
	const [needHelpDialogOpen, setNeedHelpDialogOpen] = useState(false);

	return (
		<>
			<Box
				sx={{
					position: 'absolute',
					right: { xs: 16, md: 24 },
					bottom: 'calc(100% + 16px)',
					zIndex: 1,
				}}
			>
				<Fab
					variant="extended"
					size="large"
					aria-label="Need help"
					data-test-id="need-help-fab"
					onClick={() => setNeedHelpDialogOpen(true)}
					sx={{
						backgroundColor: 'secondary.lightest',
						border: 1,
						borderStyle: 'solid',
						borderColor: 'text.Interactive',
						'&:hover': {
							backgroundColor: 'secondary.lightest',
							borderColor: 'text.Interactive',
						},
						color: 'secondary.main',
						textTransform: 'none',
					}}
				>
					<PhoneOutlinedIcon sx={{ mr: 1 }} />
					<Typography variant="bodyMediumBold" color="text.interactive">
						Need help?
					</Typography>
				</Fab>
			</Box>
			<NeedHelpDialog open={needHelpDialogOpen} onClose={() => setNeedHelpDialogOpen(false)} />
		</>
	);
}
